import request from '../../utils/request'
//获取新闻列表
export function getNewsList(query) {
  return request({
    url: '/news/list',
    method: 'get',
    params: query
  })
}
//获取新闻详情
export function getNewsDetails(id) {
  return request({
    url: `/news/${id}`,
    method: 'get',
  })
}


// WEBPACK FOOTER //
// ./src/assets/api/news.js